import { render, staticRenderFns } from "./cascader-address.vue?vue&type=template&id=1e6ef51c&scoped=true&"
import script from "./cascader-address.vue?vue&type=script&lang=js&"
export * from "./cascader-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ef51c",
  null
  
)

export default component.exports